import React from 'react';
import styles from "./StepPage.module.scss";
import { Badge, Button, TextButton, Typography } from 'seagull';
import { FooterErrorMessage } from "./FooterErrorMessage";
import { WideArrowBackward } from 'seagull/icons';
import { InfoFooter } from "./InfoFooter";
import { useResponsive } from "../contexts";
import cn from 'classnames';
import { reasonToText } from "../clientOb/ClientOnboarding.utils";
export function StepPage(_ref) {
  let {
    children,
    relationship,
    header,
    hideInfoFooter,
    showLearnMore,
    primaryBtn,
    onBackBtnClick,
    showError,
    disabledReason,
    errorMessage,
    errorTestid,
    backBtnTestid,
    testid
  } = _ref;
  const {
    isMobile,
    isDesktop
  } = useResponsive();

  if (primaryBtn.type === Button) {
    primaryBtn = /*#__PURE__*/React.cloneElement(primaryBtn, {
      fluid: true
    });
  }

  const wrappedPrimaryBtn = isDesktop ? /*#__PURE__*/React.createElement("div", {
    className: styles.ctaWrapper
  }, primaryBtn) : primaryBtn;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testid,
    className: cn(styles.root, {
      [styles.mobile]: isMobile,
      [styles.desktop]: isDesktop
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.headerAndContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: isMobile ? 'h6' : 'h4',
    weight: "normal"
  }, header), relationship.isSample && /*#__PURE__*/React.createElement(Badge, {
    outlined: true
  }, "Test agreement")), /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children), isMobile && !hideInfoFooter && /*#__PURE__*/React.createElement(InfoFooter, {
    vendorDetails: relationship.vendor,
    showLearnMoreModal: showLearnMore,
    "data-testid": "cob-step"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.primaryBtnContainer
  }, errorMessage ? /*#__PURE__*/React.createElement(FooterErrorMessage, {
    vertical: isMobile,
    showError: showError !== null && showError !== void 0 ? showError : false,
    errorMessage: errorMessage,
    "data-testid": errorTestid
  }, wrappedPrimaryBtn) : wrappedPrimaryBtn, disabledReason && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "disabled-reason-".concat(disabledReason),
    className: styles.disabledReason
  }, "To approve the agreement, ".concat(reasonToText[disabledReason], "."))), isDesktop && onBackBtnClick && /*#__PURE__*/React.createElement(TextButton, {
    skin: "secondary",
    prefixIcon: /*#__PURE__*/React.createElement(WideArrowBackward, null),
    underline: "hover",
    onClick: onBackBtnClick,
    "data-testid": backBtnTestid
  }, "Back")));
}